<template>
  <div>
    <CottiPlatform v-if="brand === 'COTTI'"/>
    <TeacatPlatform v-else/>
  </div>
</template>

<script>
import CottiPlatform from './components/cotti-platform'
import TeacatPlatform from './components/teacat-platform'

export default {
  name: 'Platform',
  components: {
    CottiPlatform,
    TeacatPlatform
  },
  data() {
    return {
      brand: ''
    }
  },
  mounted () {
    this.brand = this.$config.env.VUE_APP_BRAND
  }
  
}
</script>

<style scoped lang="scss">
</style>
